export const buildShopLink = (
  detailing,
  color,
  carId,
  utmParams = ""
): string => {
  const details = detailing && `detailing=${detailing}`
  const colorParam = color && `&color=${color}`
  const utmParamsParam = utmParams && `&${utmParams}`
  return `/shop/${carId}/?${details}${colorParam}${utmParamsParam}#/detailing`
}
